@if (layoutService.currentLayout() === 'admin') {
  <header class="bg-white p-4 flex gap-4 justify-between items-center">
    <div class="grow">
      <app-breadcrumb class="block w-full"/>
    </div>
    <i class="far fa-arrow-right-from-bracket text-error" (click)="logout()" pTooltip="Déconnexion"></i>
  </header>
} @else if (layoutService.currentLayout() === 'form') {
  <header class="form-header bg-white p-4 flex gap-4 justify-center">
    <img src="/images/branding/andy-logo-black.svg" alt="Andy"/>
  </header>
}
